import { Icon, Stack } from '@asgard/ui-library';
import { faBars } from '@fortawesome/pro-solid-svg-icons';
import { faXTwitter } from 'components/shared/XTwitterIcon';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Element, Link as LinkScroll } from 'react-scroll';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import * as S from './Fredcon26.styled';
import React, { useState } from 'react';
import { Fredcon26MobileMenu } from './Fredcon26MobileMenu';
import { Fredcon26TicketButton } from './Fredcon26TicketButton';
import { Fredcon26Speaker } from './Fredcon26Speaker';
import { Fredcon26AgendaItem } from './Fredcon26AgendaItem';
import { Fredcon26PartnerBadge } from './Fredcon26PartnerBadge';
import { TelegramIcon } from './TelegramIcon';
import { Fredcon26Cursor } from './Fredcon26Cursor';

const BASE_URL = 'https://www.getmanfred.com';

export const Fredcon26: React.FC = () => {
  const { t } = useI18n('fredcon26');
  const { locale } = useRouter();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const WRAPPER_ID = 'fredcon-page-wrapper';

  const Header = (
    <S.Header>
      <S.HeaderContent>
        <S.HeaderGroup>
          <S.MobileMenuButton type="button" onClick={() => setIsMenuOpen(true)}>
            <Icon icon={faBars} size="xl" />
          </S.MobileMenuButton>

          <Link href={BASE_URL} passHref>
            <S.HeaderNavLogo>
              <img
                src={getPublicPath(`/images/fredcon26/manfred-logo.png`)}
                alt="Manfred logo"
              />
            </S.HeaderNavLogo>
          </Link>
        </S.HeaderGroup>

        <S.HeaderActions>
          <S.HeaderNav>
            {[
              { to: 'agenda', label: t('fredcon.header.nav-1') },
              { to: 'donde', label: t('fredcon.header.nav-2') },
              { to: 'speakers', label: t('fredcon.header.nav-3') },
              { to: 'contacto', label: t('fredcon.header.nav-5') }
            ].map((item) => (
              <S.NavItem key={item.to}>
                <LinkScroll
                  to={item.to}
                  href={`#${item.to}`}
                  duration={500}
                  spy={true}
                  offset={-64}
                  containerId={WRAPPER_ID}
                >
                  {item.label}
                </LinkScroll>

                <div className="underline">
                  {Array.from({ length: 4 })
                    .map(() => [
                      { color: '#3053f9' },
                      { color: '#3053f9', opacity: 0 },
                      { color: '#c5fe79' },
                      { color: '#3053f9' },
                      { color: '#ffb6fb' },
                      { color: '#3053f9', opacity: 0 },
                      { color: '#3053f9' },
                      { color: '#3053f9' },
                      { color: '#3053f9' },
                      { color: '#ffb6fb' },
                      { color: '#3053f9' },
                      { color: '#3053f9', opacity: 0 },
                      { color: '#3053f9' },
                      { color: '#3053f9', opacity: 0 },
                      { color: '#c5fe79' },
                      { color: '#3053f9' },
                      { color: '#3053f9' },
                      { color: '#3053f9', opacity: 0 },
                      { color: '#ff6e23' },
                      { color: '#3053f9', opacity: 0 },
                      { color: '#3053f9' },
                      { color: '#3053f9' },
                      { color: '#836fff' },
                      { color: '#c5fe79', opacity: 0 },
                      { color: '#3053f9' },
                      { color: '#3053f9', opacity: 0 },
                      { color: '#3053f9' },
                      { color: '#3053f9', opacity: 0 },
                      { color: '#ff6e23' },
                      { color: '#3053f9', opacity: 0 },
                      { color: '#3053f9' },
                      { color: '#c5fe79', opacity: 0 },
                      { color: '#3053f9' },
                      { color: '#3053f9', opacity: 0 },
                      { color: '#ffb6fb' },
                      { color: '#3053f9' },
                      { color: '#836fff' },
                      { color: '#3053f9', opacity: 0 },
                      { color: '#3053f9' },
                      { color: '#3053f9', opacity: 0 },
                      { color: '#3053f9' },
                      { color: '#836fff' },
                      { color: '#c5fe79', opacity: 0 },
                      { color: '#3053f9', opacity: 0 },
                      { color: '#3053f9', opacity: 0 }
                    ])
                    .flat()
                    .map((pixel, i) => (
                      <S.Pixel
                        key={i}
                        color={pixel.color}
                        opacity={pixel.opacity}
                      />
                    ))}
                </div>
              </S.NavItem>
            ))}
          </S.HeaderNav>

          <Fredcon26TicketButton />
        </S.HeaderActions>
        <Fredcon26MobileMenu
          isOpen={isMenuOpen}
          onClose={() => setIsMenuOpen(false)}
        />
      </S.HeaderContent>
    </S.Header>
  );

  return (
    <S.PageWrapper id={WRAPPER_ID}>
      <Fredcon26Cursor />
      <S.Fredcon26GlobalStyles />
      <S.Root>
        {Header}

        <S.Hero>
          <S.HeroInner>
            <S.HeroSubTitle>{t('fredcon.hero.title-pre')}</S.HeroSubTitle>

            <S.HeroTitle>
              <img
                src={getPublicPath(`/images/fredcon26/fredcon-logo-white.png`)}
                alt={t(`fredcon.hero.logo`)}
                className="logo-img"
              />
            </S.HeroTitle>

            <S.PoweredBy>
              <p>{t('fredcon.powered-by')}</p>
              <img
                src={getPublicPath('/images/fredcon26/google-cloud-hero.svg')}
                alt="Powered by Google Cloud"
              />
            </S.PoweredBy>

            <S.HeroTagline>{t('fredcon.hero.desc')}</S.HeroTagline>

            <S.HeroDate>
              <p>{t('fredcon.hero.date')}</p>
            </S.HeroDate>

            <Fredcon26TicketButton
              text={t('fredcon.hero.view-program')}
              href="#agenda"
            />
          </S.HeroInner>
        </S.Hero>

        <S.Speakers>
          <Element name="speakers" id="speakers"></Element>
          <h2>{t('fredcon.speakers.title')}</h2>

          <S.SpeakersContainer>
            <Stack
              wrap
              gap="3xl"
              contentAlign="center"
              style={{ width: '100%' }}
            >
              {Array.from({ length: 9 }).map((_, index) => {
                const pixelColors = [
                  '#3053f9',
                  '#ff6e23',
                  '#836fff',
                  '#FFB6FB',
                  '#c5fe79',
                  '#c5fe79',
                  '#ff6e23',
                  '#836fff',
                  '#FFB6FB'
                ];
                const borderColor = pixelColors[index % pixelColors.length];
                const speakerName = t(
                  `fredcon.speakers.speaker-${index + 1}.name`
                );
                const speakerSurname = t(
                  `fredcon.speakers.speaker-${index + 1}.surname`
                );
                const speakerDescKey = `fredcon.speakers.speaker-${
                  index + 1
                }.desc`;
                const linkedinUrl = t(
                  `fredcon.speakers.speaker-${index + 1}.linkedin`
                );

                return (
                  <Fredcon26Speaker
                    key={index}
                    borderColor={borderColor}
                    name={speakerName}
                    surname={speakerSurname}
                    descriptionKey={speakerDescKey}
                    linkedinUrl={linkedinUrl}
                    speakerPhoto={getPublicPath(
                      `/images/fredcon26/speaker-${index + 1}.png`
                    )}
                  />
                );
              })}
            </Stack>
          </S.SpeakersContainer>
        </S.Speakers>

        <S.InfoWrapper>
          <S.InfoInner>
            <S.What>
              <h2>{t('fredcon.what.title')}</h2>
              <S.WhatDesc>
                <HtmlTrans ns="fredcon26" i18nKey="fredcon.what.desc" />
              </S.WhatDesc>
            </S.What>

            <S.Where>
              <h2>
                <Element name="donde" id="donde"></Element>
                {t('fredcon.where.title')}
              </h2>
              <div className="where-content">
                <S.WhereDesc>
                  <HtmlTrans ns="fredcon26" i18nKey="fredcon.where.desc" />
                </S.WhereDesc>

                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3037.9897840543754!2d-3.7068436000000005!3d40.4090771!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd4227fc14e5d533%3A0xd840f5b434384bc7!2sEspacio%20Rastro%20Madrid!5e0!3m2!1sen!2ses!4v1747216832762!5m2!1sen!2ses"
                  style={{ border: 0 }}
                  allowFullScreen={false}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </S.Where>
          </S.InfoInner>
        </S.InfoWrapper>

        <S.Agenda>
          <Element name="agenda" id="agenda"></Element>
          <h2>{t('fredcon.agenda.title')}</h2>

          <S.AgendaList>
            {Array.from({ length: 15 }).map((_, index) => {
              const itemKey = `fredcon.agenda.item-${index + 1}`;
              const getTranslation = (key: string): string => {
                const value = t(key);
                return value === key ? '' : value;
              };
              return (
                <Fredcon26AgendaItem
                  key={index}
                  startTime={getTranslation(`${itemKey}.startTime`)}
                  endTime={getTranslation(`${itemKey}.endTime`)}
                  title={getTranslation(`${itemKey}.title`)}
                  subtitle={getTranslation(`${itemKey}.subtitle`)}
                  speaker={getTranslation(`${itemKey}.speaker`)}
                  isBreak={getTranslation(`${itemKey}.isBreak`) === 'true'}
                />
              );
            })}
          </S.AgendaList>
        </S.Agenda>

        <S.Tickets>
          <Element name="entradas" id="entradas"></Element>
          <S.TicketsInner>
            <S.TicketsSubTitle>
              {t('fredcon.tickets.subtitle')}
            </S.TicketsSubTitle>
            <S.TicketsTitle>{t('fredcon.tickets.title')}</S.TicketsTitle>
            <S.TicketsDesc>
              <HtmlTrans ns="fredcon26" i18nKey="fredcon.tickets.desc" />
            </S.TicketsDesc>
            <Fredcon26TicketButton />
          </S.TicketsInner>
        </S.Tickets>

        <S.Partners>
          <Element name="partners" id="partners"></Element>
          <h2>{t('fredcon.partners.title')}</h2>

          <S.Tiers>
            <S.Tier>
              <Fredcon26PartnerBadge text="King" />
              <S.Partner
                href={t(`fredcon.partners.partner-google.url`)}
                target="_blank"
                tier="king"
              >
                <img
                  src={getPublicPath('/images/fredcon26/partner-google.png')}
                  alt={t(`fredcon.partners.partner-google.name`)}
                />
              </S.Partner>
            </S.Tier>

            <S.Tier style={{ marginTop: '12px' }}>
              <Fredcon26PartnerBadge text="Manfredo Partners" />
              <S.PartnerList className="partner-list-3-max">
                <S.Partner
                  href={t(`fredcon.partners.partner-540.url`)}
                  target="_blank"
                  tier="partner"
                >
                  <img
                    src={getPublicPath('/images/fredcon26/partner-540.png')}
                    alt={t(`fredcon.partners.partner-540.name`)}
                  />
                </S.Partner>
                <S.Partner
                  href={t(`fredcon.partners.partner-orbitant.url`)}
                  target="_blank"
                  tier="partner"
                >
                  <img
                    src={getPublicPath(
                      '/images/fredcon26/partner-orbitant.png'
                    )}
                    alt={t(`fredcon.partners.partner-orbitant.name`)}
                  />
                </S.Partner>
                <S.Partner
                  href={t(`fredcon.partners.partner-sngular.url`)}
                  target="_blank"
                  tier="partner"
                >
                  <img
                    src={getPublicPath('/images/fredcon26/partner-sngular.png')}
                    alt={t(`fredcon.partners.partner-sngular.name`)}
                  />
                </S.Partner>
                <S.Partner
                  href={t(`fredcon.partners.partner-next-digital.url`)}
                  target="_blank"
                  tier="collaborator"
                >
                  <img
                    src={getPublicPath(
                      '/images/fredcon26/partner-next-digital.png'
                    )}
                    alt={t(`fredcon.partners.partner-next-digital.name`)}
                  />
                </S.Partner>
                <S.Partner
                  href={t(`fredcon.partners.partner-helmcode.url`)}
                  target="_blank"
                  tier="partner"
                >
                  <img
                    src={getPublicPath(
                      '/images/fredcon26/partner-helmcode.png'
                    )}
                    alt={t(`fredcon.partners.partner-helmcode.name`)}
                  />
                </S.Partner>
              </S.PartnerList>
            </S.Tier>

            <S.Tier style={{ marginTop: '12px' }}>
              <Fredcon26PartnerBadge text="Manfredo Collaborators" />
              <S.PartnerList>
                <S.Partner
                  href={t(`fredcon.partners.partner-osohub.url`)}
                  target="_blank"
                  tier="collaborator"
                >
                  <img
                    src={getPublicPath('/images/fredcon26/partner-osohub.png')}
                    alt={t(`fredcon.partners.partner-osohub.name`)}
                  />
                </S.Partner>
                <S.Partner
                  href={t(`fredcon.partners.partner-raiola.url`)}
                  target="_blank"
                  tier="collaborator"
                >
                  <img
                    src={getPublicPath('/images/fredcon26/partner-raiola.png')}
                    alt={t(`fredcon.partners.partner-raiola.name`)}
                  />
                </S.Partner>
                <S.Partner
                  href={t(`fredcon.partners.partner-panel.url`)}
                  target="_blank"
                  tier="partner"
                >
                  <img
                    src={getPublicPath('/images/fredcon26/partner-panel.jpg')}
                    alt={t(`fredcon.partners.partner-panel.name`)}
                  />
                </S.Partner>
                <S.Partner
                  href={t(`fredcon.partners.partner-iceye.url`)}
                  target="_blank"
                  tier="partner"
                >
                  <img
                    src={getPublicPath('/images/fredcon26/partner-iceye.jpg')}
                    alt={t(`fredcon.partners.partner-iceye.name`)}
                  />
                </S.Partner>
              </S.PartnerList>
            </S.Tier>
          </S.Tiers>

          <S.PartnersDivider />

          <S.PartnersFooterText>
            <HtmlTrans ns="fredcon26" i18nKey="fredcon.partners.footer-text" />
          </S.PartnersFooterText>
        </S.Partners>

        <S.Footer>
          <Element name="contacto" id="contacto"></Element>

          <S.FooterContent>
            <S.FooterRow1>
              <S.FredConLogoBlack>
                <span>{t('fredcon.the-one-and-only')}</span>
                <img
                  src={getPublicPath(
                    '/images/fredcon26/fredcon-logo-black.png'
                  )}
                  alt="FredCon 26"
                />
              </S.FredConLogoBlack>

              <S.PoweredByGoogleBlack>
                <span>{t('fredcon.powered-by')}</span>
                <img
                  src={getPublicPath(
                    '/images/fredcon26/powered-google-black.png'
                  )}
                  alt="Powered by Google"
                />
              </S.PoweredByGoogleBlack>

              <S.ManfredLogoMonocolor>
                <img
                  src={getPublicPath(
                    '/images/fredcon26/manfred-logo-monocolor.png'
                  )}
                  alt="Manfred"
                />
              </S.ManfredLogoMonocolor>
            </S.FooterRow1>

            <S.FooterRow2>
              <S.Copyright>
                © {new Date().getFullYear()} <strong>Manfred Tech</strong> S.L.
              </S.Copyright>
              <S.FooterLinks>
                <a
                  href={`${BASE_URL}${getAppUrl(APP_URLS.termsOfUse, locale)}`}
                  target="_blank"
                >
                  {t('fredcon.footer.nav.terms')}
                </a>
                <a
                  href={`${BASE_URL}${getAppUrl(
                    APP_URLS.privacyPolicy,
                    locale
                  )}`}
                  target="_blank"
                >
                  {t('fredcon.footer.nav.privacy')}
                </a>
                <a
                  href={`${BASE_URL}${getAppUrl(APP_URLS.cookies, locale)}`}
                  target="_blank"
                >
                  {t('fredcon.footer.nav.cookies')}
                </a>
              </S.FooterLinks>
              <S.SocialLinks>
                <a href="https://twitter.com/getmanfred" target="_blank">
                  <Icon icon={faXTwitter} />
                </a>
                <a href="https://t.me/getmanfred" target="_blank">
                  <TelegramIcon />
                </a>
              </S.SocialLinks>
            </S.FooterRow2>
          </S.FooterContent>
        </S.Footer>
      </S.Root>
    </S.PageWrapper>
  );
};
